/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DownloadClientPhoto$Params {

/**
 * The ID of the client.
 */
  clientID: number;
      body?: {
'photoID'?: number;
}
}

export function DownloadClientPhoto(http: HttpClient, rootUrl: string, params: DownloadClientPhoto$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, DownloadClientPhoto.PATH, 'post');
  if (params) {
    rb.path('clientID', params.clientID, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

DownloadClientPhoto.PATH = '/api/Clients/DownloadClientPhoto/{clientID}';
